import React from 'react'
import Tab from 'react-bootstrap/Tab'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Nav from 'react-bootstrap/Nav'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import MailingList from 'admin/mailing_lists/MailingList'

class MailingLists extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mailingLists: []
    }

    this.deleteMailingList = this.deleteMailingList.bind(this);
  }
  componentDidMount() {
    this.setState({
      mailingLists: this.props.mailingLists
    })
  }

  deleteMailingList(list_id)
  {
    $.ajax({
      url: "/datapulse/admin/mailing_lists/" + list_id,
      type: "DELETE",
      data: "",
      dataType: 'json',
      success: (data) => {
        const newMailingLists = this.props.state.filter((l) => l.id != list_id);
        this.setState({ mailingLists: newMailingLists });
        DP_FLASH([{ type: 'success', message: 'Mailing list successfully deleted' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed delete mailing list' }])
      }
    })
  }

  createMailingList()
  {
    $.ajax({
      url: "/datapulse/admin/mailing_lists",
      type: "POST",
      data: {
        mailing_list: {
          name: "New Mailing List",
          description: "description..."
        }
      },
      dataType: 'json',
      success: (data) => {
        const newMailingLists = [...this.state.mailingLists]
        newMailingLists.push(data);
        this.setState({ mailingLists: newMailingLists });
        DP_FLASH([{ type: 'success', message: 'Mailing list successfully deleted' }])
      },
      error: (data) => {
        DP_FLASH([{ type: 'danger', message: 'Failed delete mailing list' }])
      }
    })
  }

  render() {
    return (
      <div className="off-color-bg standard-page-padding">
        <div className="d-flex mb-3 justify-content-end">
          <Button variant="success" onClick={(e) => this.createMailingList()}>
            + Create Mailing List
          </Button>
        </div>
        <Row className="mailing-list ">
          {
            this.state.mailingLists.map((l) => {
              return (
                <Col key={l.id} sm={12} md={6}>
                  <MailingList mailingList={l} deleteMailingList={this.deleteMailingList} />
                </Col>
              )
            })
          }
        </Row>
      </div>
    );
  }
}

export default MailingLists;
